function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhiteRecoveryCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16,
    viewBox: "0 0 16.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-call",
    d: "M20.029 17.031a13.44 13.44 0 0 0-2.808-1.879c-.841-.4-1.15-.4-1.745.033-.5.358-.816.691-1.387.567A8.275 8.275 0 0 1 11.3 13.69a8.215 8.215 0 0 1-2.06-2.79c-.121-.575.212-.891.567-1.387.429-.6.442-.9.033-1.745a13.174 13.174 0 0 0-1.878-2.805c-.612-.612-.75-.479-1.087-.358a6.187 6.187 0 0 0-1 .529A3 3 0 0 0 4.683 6.4c-.237.512-.512 1.466.887 3.957a22.081 22.081 0 0 0 3.882 5.178 22.167 22.167 0 0 0 5.178 3.882c2.491 1.4 3.445 1.125 3.957.887a2.952 2.952 0 0 0 1.262-1.2 6.187 6.187 0 0 0 .529-1c.13-.323.268-.461-.349-1.073z",
    transform: "translate(-4.49 -4.502)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhiteRecoveryCall);
export default __webpack_public_path__ + "static/media/phoneWhiteRecoveryCall.99ab5bcbc7920ecc3fe806416c4a133a.svg";
export { ForwardRef as ReactComponent };